import React from "react";
import s from "./PitchDetectionSelectedPage.module.scss";
import Button from "../../common/Button";
import onboarding from "../../../services/onboarding/onboarding";
import BackButton from "../../common/BackButton";
import {miscImages} from "../../../config/config";
import {inAppAnalyticsService} from "../../../services/inAppAnalyticsService";

const screenClass = 'onboarding/pitch-detection-selected';

export default function PitchDetectionSelectedPage() {
  return (
    <div className={s.pitchDetectionSelected}>
      <header className={s.top}>
        <BackButton useClassName={s.backButton} analyticsIdentifier={'pitch-detection-selected-back'} analyticsScreenClass={screenClass}/>
        <div className={s.headerContent}>
          <img className={s.microphone} src={miscImages.whiteMicrophone} width={56} height={56} alt='' loading={"eager"} />
          <h1 className={s.overlayText}>
              Microphone will be used for feedback
          </h1>
        </div>
      </header>
      <main className={s.body}>
        <h1>Microphone will be used for feedback</h1>
        <p>
            You may have to give Playground Sessions permission to use the microphone on your device before
            playing your first lesson. Feedback and a score will be provided after you play.
        </p>
        <Button additionalClassName={s.startPlayingButton} text="Start Playing" buttonType={"secondary"} onClick={() => {
          inAppAnalyticsService.onButton_press('pitch-detection-selected-start-playing', {screenClass});
          onboarding.completeOnboarding();
        }}/>
      </main>
    </div>
  );
}
